import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-github',
  templateUrl: './github.component.html',
  styleUrls: ['./github.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GithubIconComponent {}
